import { connect } from 'react-redux';

import { isUserLoggedIn } from 'apps/user/helpers';
import { logout } from 'apps/sso/actions/sso';
import { closeMobileNav, setMobileNavLevel } from '../actions/topNavigation';

import NavigationMenuContent from '../components/NavigationMenuContent';

export default connect(
  state => ({
    isLoggedIn: isUserLoggedIn(state.user),
  }),
  {
    logout,
    closeMobileNav,
    setMobileNavLevel,
  }
)(NavigationMenuContent);
